import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';

function Description_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const text = staticComponentValueConverter(item?.data?.text);
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        textAlign: 'left',
        gap: 5,
      }}
      className="py-2.5 mx-3 "
    >
      {customization?.isShowDescriptionTitle === 'show' && (
        <div
          style={{
            fontSize: customization?.descriptionTitleTextSize,
            fontWeight: customization?.descriptionTitleTextWeight,
            color: customization?.descriptionTitleTextColor,
            textAlign: customization?.descriptionTitleTextAlignment,
            fontStyle: customization?.descriptionTitleTextStyle,
            marginBottom: 10,
            width: '100%',
          }}
        >
          {item?.data?.text}
        </div>
      )}
      {customization?.isShowProductTitle === 'show' && (
        <div
          style={{
            fontSize: customization?.ProductTitleTextSize,
            fontWeight: customization?.ProductTitleTextWeight,
            color: customization?.ProductTitleTextColor,

            fontStyle: customization?.ProductTitleTextStyle,
            marginBottom: 10,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{ width: '100%', textAlign: customization?.ProductTitleTextAlignment }}
            dangerouslySetInnerHTML={{ __html: firstProduct?.description }}
          ></div>
        </div>
      )}

      <div dangerouslySetInnerHTML={{ __html: firstProduct?.description }}></div>
    </div>
  );
}

export default Description_1;
